module.exports = __webpack_public_path__ + "img/Olav_og_Kari_Konfliktene.2facbe4a.jpg";